


import Vue from "vue"
import { RouteInvitationLink } from "@/types/data"
import Card from '@/components/global/Card.vue'
import { ActionTypes } from "@/enums/vuex"

export default Vue.extend({
    components: { Card },
    name: "InvitationLinkInfo",
    data(): {
		checked: boolean
        loading: boolean
	} {
		return {
			checked: false,
            loading: false
		}
	},
    async mounted() {
		this.checked = this.getRouteInvitationLink.checked;
        // Ensure existingVerjiAccount flag is set to false, to avoid cached value having effect on later registrations
        await this.$store.dispatch(ActionTypes.setExistingVerjiAccount, false)
	},
	watch: {
		getRouteInvitationLink: {
            deep: true,
            handler(){
                if(this.getRouteInvitationLink.checked == true){
					this.checked = true
				}
            }
        }
	},
    computed: {
        getRouteInvitationLink(): RouteInvitationLink {
            return this.$store.state.routeInvitationLink
        },
        customerName(): RouteInvitationLink {
            return this.$store.state.routeInvitationLink.response.customerName
        },
        name(): RouteInvitationLink {
            return this.$store.state.routeInvitationLink.response.personName
        },
	},
    methods: {
       async loginBankId(): Promise<void> {

            this.$router.push(this.$store.state.routeInvitationLink.id + '/bankId')
            
        }
    }
})

